import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";

const ProductCard = ({
  product,
  discount_percent,
  initialQty,
  handleQuantityChange,
  handleAddClick,
  background,
  btnType,
}: any) => {
  const [qty, setQty] = useState(initialQty || 0);
  const discountedPrice =
    Number(product.msrp / product.packed) * (1 - discount_percent / 100);
  const handleQtyChange = (value: number) => {
    const safeValue = Math.max(0, value);
    setQty(safeValue);
    handleQuantityChange(safeValue, {
      product_id: product.product_id,
      name: product.name,
      packed: Number(product.packed),
      unit: product.unit,
      msrp: product.msrp,
    });
  };
  useEffect(() => {
    setQty(initialQty || 0);
  }, [initialQty]);
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "14px",
        overflow: "hidden",
        border: background ? `2px solid #bcbcbc` : "1px solid #e0ead9",
        backgroundColor: "#fff",
        transition: "all 0.22s ease",
        // "&:hover": {
        //   boxShadow: "0 6px 20px rgba(3,54,10,0.09)",
        //   transform: "translateY(-2px)",
        // },
        // "&:hover img": { transform: "scale(1.04)" },
      }}
    >
      {/* Image */}
      <Box sx={{ height: 160, overflow: "hidden", position: "relative" }}>
        <Box
          component="img"
          src={`https://order.kalamata.ca/uploads/products/${product.image}`}
          alt={product.name}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            transition: "transform 0.3s ease",
          }}
        />
        {background && (
          <Box
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#03360a",
              color: "#fff",
              fontSize: 10,
              fontWeight: 600,
              px: 1,
              py: 0.4,
              borderRadius: "20px",
            }}
          >
            In order
          </Box>
        )}
      </Box>

      <CardContent sx={{ p: "14px 16px 16px" }}>
        {/* Name + pack info */}
        <Typography
          fontWeight={600}
          fontSize={15}
          sx={{
            mb: 0.25,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "#1a1a1a",
          }}
        >
          {product.name}
        </Typography>
        {/* <Typography fontSize={12} sx={{ color: "#888", mb: 1.5 }}>
        Pack of {product.packed} · {product.unit}
      </Typography> */}

        {/* Price row */}
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            justifyContent: "space-between",
            mb: 1.75,
            pb: 1.5,
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.4 }}>
            <Typography
              fontWeight={700}
              fontSize={20}
              sx={{ color: "#787878" }}
            >
              ${discountedPrice.toFixed(2)}
            </Typography>
            <Typography fontSize={12} sx={{ color: "#888" }}>
              per {product.unit}
            </Typography>
          </Box>
          <Box
            sx={{
              fontSize: 11,
              fontWeight: 500,
              backgroundColor: "#eef4eb",
              color: "#239848",
              px: 1,
              py: 0.3,
              borderRadius: "20px",
            }}
          >
            Pack of {product.packed} · {product.unit}
          </Box>
        </Box>

        {/* Stepper + button */}
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#f7f9f5",
              border: "1px solid #d6e4d0",
              borderRadius: "8px",
              overflow: "hidden",
              flexShrink: 0,
            }}
          >
            <IconButton
              size="small"
              onClick={() => handleQtyChange(qty - 1)}
              disabled={qty === 0}
              sx={{ width: 30, height: 32, borderRadius: 0, color: "#03360a" }}
            >
              {qty === 1 ? (
                <DeleteIcon sx={{ fontSize: 14 }} />
              ) : (
                <RemoveIcon sx={{ fontSize: 14 }} />
              )}
            </IconButton>
            <Typography
              sx={{
                width: 24,
                textAlign: "center",
                fontSize: 14,
                fontWeight: 600,
                color: "#03360a",
              }}
            >
              {qty}
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleQtyChange(qty + 1)}
              sx={{ width: 30, height: 32, borderRadius: 0, color: "#03360a" }}
            >
              <AddIcon sx={{ fontSize: 14 }} />
            </IconButton>
          </Box>

          <Button
            fullWidth
            variant={btnType}
            size="small"
            onClick={() =>
              handleAddClick({
                product_id: product.product_id,
                name: product.name,
              })
            }
            sx={{
              height: 32,
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              ...(btnType === "contained"
                ? {
                    backgroundColor: "#03360a",
                    "&:hover": { backgroundColor: "#11671c" },
                  }
                : {
                    borderColor: "#03360a",
                    color: "#03360a",
                    "&:hover": { backgroundColor: "#eef4eb" },
                  }),
            }}
          >
            {btnType === "contained" ? "Added" : "Add"}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
